/** Brand colors matched to Bazm-e-Musk logo metallic gold */
export const BRAND_GOLD = {
  highlight: '#F9E076',
  primary: '#D4AF37',
  mid: '#C5A059',
  shadow: '#7A5C2E',
  black: '#000000',
} as const

export const CHART_GOLD_COLORS = [
  BRAND_GOLD.primary,
  BRAND_GOLD.mid,
  BRAND_GOLD.highlight,
  BRAND_GOLD.shadow,
  '#9A7D32',
]

export const LOGO_PATH = '/logo.png'
export const FAVICON_16_PATH = '/favicon-16x16.png'
export const FAVICON_32_PATH = '/favicon-32x32.png'
export const APPLE_TOUCH_ICON_PATH = '/apple-touch-icon.png'
export const LOGO_ALT = 'Bazm-e-Musk — Luxury Attars'

/** Homepage hero banner image specs (matches admin preview & storefront crop). */
export const BANNER_IMAGE_WIDTH = 1920
export const BANNER_IMAGE_HEIGHT = 820
export const BANNER_IMAGE_ASPECT = '21:9'
export const BANNER_IMAGE_DIMENSIONS = `${BANNER_IMAGE_WIDTH} × ${BANNER_IMAGE_HEIGHT} px`
export const BANNER_IMAGE_FORMATS = 'JPG, PNG, or WEBP'
